// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// ------- PROD -----------

const firebaseConfig = {
  apiKey: "AIzaSyDLVqJXvqA9LMur8_1lepcDqy96j_kReqo",
  authDomain: "autorewards-1fc69.firebaseapp.com",
  databaseURL: "https://autorewards-1fc69.firebaseio.com",
  projectId: "autorewards-1fc69",
  storageBucket: "autorewards-1fc69.firebasestorage.app",
  messagingSenderId: "142746322756",
  appId: "1:142746322756:web:afb45fc416faa5fd197911",
  measurementId: "G-E27ZPEWBVE"
};
// ------- PROD -----------

// ------- Staging -----------
// const firebaseConfig = {
//   apiKey: "AIzaSyB2oSj9zBuXnjlNUNtZuqYcDel_1OtJoHY",
//   authDomain: "autorewards-staging.firebaseapp.com",
//   projectId: "autorewards-staging",
//   storageBucket: "autorewards-staging.firebasestorage.app",
//   messagingSenderId: "439548804351",
//   appId: "1:439548804351:web:430ae67d3538291ce0e0ca",
//   measurementId: "G-R7H94758HN"
// };
// ------- Staging -----------

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage
const storage = getStorage(app);

// Export the storage to use it in other files
export { storage };